import Router from './router';
import useAuthCheck from './v2-custom-hooks/useAuthCheck.hook';
import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
import useClearSessionStorageOnPathChange from './v2-custom-hooks/useClearSessionStorageOnPathChange';
import useNotificationStore from './v2-pages/notification/store/useNotificationStore';
import { useEffect } from 'react';

export default function App() {
	const token = useNotificationStore((state) => state.token);
	const initSocket = useNotificationStore((state) => state.initSocket);
	const cleanupSocket = useNotificationStore((state) => state.cleanupSocket);

	// Inicializar el socket cuando la aplicación se carga si hay un token guardado
	useEffect(() => {
		if (token) {
			initSocket(token);
		}

		// Limpiar el socket cuando el componente se desmonte
		return () => {
			cleanupSocket();
		};
	}, [initSocket, cleanupSocket, token]);

	useAuthCheck();
	useClearSessionStorageOnPathChange();
	return (
		<I18nextProvider i18n={i18next}>
			<Router />
		</I18nextProvider>
	);
}
